module.exports = __webpack_public_path__ + "static/media/change-direction.3dab4216.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/change-direction.svg
// module id = 229
// module chunks = 0